module.exports = __webpack_public_path__ + "static/media/installed.930d9c9e.png";